var navbar = document.querySelector('nav');
if (document.getElementById("nav-toggler") != null) {
    document.getElementById("nav-toggler").addEventListener("click", function () {
        navbar.classList.toggle('in');
    });
}
